(function () {
  const targetSelector = 'b, strong';
  const trailingWhitespacePattern = /\s+$/;
  const leadingWhitespacePattern = /^\s+/;
  const wordEndingPattern = /[0-9A-Za-zÀ-ÖØ-öø-ÿĀ-ž’']$/;
  const wordStartingPattern = /^[0-9A-Za-zÀ-ÖØ-öø-ÿĀ-ž]/;

  function hasTargets(root) {
    return !!(root && root.querySelector && root.querySelector(targetSelector));
  }

  function getFirstTextNode(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    return walker.nextNode();
  }

  function getLastTextNode(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();
    let lastNode = null;

    while (textNode) {
      lastNode = textNode;
      textNode = walker.nextNode();
    }

    return lastNode;
  }

  function getAdjacentTextSibling(element, direction) {
    let sibling = direction === 'previous' ? element.previousSibling : element.nextSibling;

    while (sibling) {
      if (sibling.nodeType === Node.TEXT_NODE) {
        return sibling;
      }

      if (sibling.nodeType === Node.COMMENT_NODE) {
        sibling = direction === 'previous' ? sibling.previousSibling : sibling.nextSibling;
        continue;
      }

      return null;
    }

    return null;
  }

  function normalizeBoundary(element) {
    const previousTextNode = getAdjacentTextSibling(element, 'previous');
    const nextTextNode = getAdjacentTextSibling(element, 'next');
    const firstTextNode = getFirstTextNode(element);
    const lastTextNode = getLastTextNode(element);

    if (previousTextNode && firstTextNode) {
      const previousValue = previousTextNode.nodeValue || '';
      const firstValue = firstTextNode.nodeValue || '';
      const trimmedPreviousValue = previousValue.replace(trailingWhitespacePattern, '');
      const trimmedFirstValue = firstValue.replace(leadingWhitespacePattern, '');

      if (
        trimmedPreviousValue &&
        trimmedFirstValue &&
        wordEndingPattern.test(trimmedPreviousValue) &&
        wordStartingPattern.test(trimmedFirstValue)
      ) {
        previousTextNode.nodeValue = trimmedPreviousValue + ' ';
        firstTextNode.nodeValue = trimmedFirstValue;
      }
    }

    if (nextTextNode && lastTextNode) {
      const nextValue = nextTextNode.nodeValue || '';
      const lastValue = lastTextNode.nodeValue || '';
      const trimmedNextValue = nextValue.replace(leadingWhitespacePattern, '');
      const trimmedLastValue = lastValue.replace(trailingWhitespacePattern, '');

      if (
        trimmedNextValue &&
        trimmedLastValue &&
        wordEndingPattern.test(trimmedLastValue) &&
        wordStartingPattern.test(trimmedNextValue)
      ) {
        lastTextNode.nodeValue = trimmedLastValue;
        nextTextNode.nodeValue = ' ' + trimmedNextValue;
      }
    }
  }

  function normalizeSpacing(root) {
    if (!root) {
      return;
    }

    if (!hasTargets(root) && !(root.matches && root.matches(targetSelector))) {
      return;
    }

    const elements = root.matches && root.matches(targetSelector)
      ? [root]
      : root.querySelectorAll
        ? root.querySelectorAll(targetSelector)
        : [];

    elements.forEach(normalizeBoundary);
  }

  let animationFrameId = null;

  function scheduleNormalization(root) {
    const targetRoot = root || document.body;

    if (!targetRoot) {
      return;
    }

    if (!hasTargets(targetRoot) && !(targetRoot.matches && targetRoot.matches(targetSelector))) {
      return;
    }

    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
    }

    animationFrameId = requestAnimationFrame(function () {
      animationFrameId = null;
      normalizeSpacing(targetRoot);
    });
  }

  function init() {
    normalizeSpacing(document.body);

    if (!document.body || !hasTargets(document.body)) {
      return;
    }

    [350, 1200].forEach(function (delay) {
      window.setTimeout(function () {
        scheduleNormalization(document.body);
      }, delay);
    });

    window.addEventListener('load', function () {
      scheduleNormalization(document.body);
    });

    document.addEventListener('shopify:section:load', function (event) {
      scheduleNormalization(event.target || document.body);
    });

    document.addEventListener('shopify:section:reorder', function (event) {
      scheduleNormalization(event.target || document.body);
    });

    document.addEventListener('ecom-products-init', function (event) {
      scheduleNormalization(event.target || document.body);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
